import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { cn } from '@bem-react/classname'
import { AnimatePresence } from 'framer-motion'

import { Button } from '@/components/UI/Button'

import './Cookies.scss'

interface ICookies {
  className?: string
  isCookies: boolean
  setIsCookies: (isCookies: boolean) => void
}

const cnCookies = cn('Cookies')

export const Cookies: FC<ICookies> = ({
  className,
  isCookies,
  setIsCookies,
}: ICookies) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const onClick = () => {
    setIsCookies(false)
    localStorage.setItem('cookies', 'false')
  }

  const onClickMore = () => {
    navigate('/privacy-policy')
    setIsCookies(false)
    localStorage.setItem('cookies', 'false')
  }

  return (
    <>
      <AnimatePresence>
        {isCookies && <div className={cnCookies('overlay')}></div>}
      </AnimatePresence>
      <AnimatePresence>
        {isCookies && (
          <div className={cnCookies('modal', [className])}>
            <div className={cnCookies('center')}>
              <div className={cnCookies('icon')}>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                >
                  <path
                    d='M12 8H12.01M12 11V16M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z'
                    stroke='#30DAAD'
                    stroke-width='1.5'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                  />
                </svg>
              </div>

              <div className={cnCookies('wrap')}>
                <div className={cnCookies('text')}>{t('cookies-text')}</div>
              </div>

              <div className={cnCookies('actions')}>
                <Button onClick={onClickMore}>{t('cookies-btn-more')}</Button>
                <Button color='dark' onClick={onClick}>
                  {t('cookies-btn-gotit')}
                </Button>
                <Button color='light' onClick={onClick}>
                  {t('cookies-btn-reject')}
                </Button>
              </div>
            </div>
          </div>
        )}
      </AnimatePresence>
    </>
  )
}
